import { ChevronLeft, ChevronRight } from "@mui/icons-material"
import { IconButton, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    carouselContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem",
    },
    carouselText: {
        fontSize: "1rem",
    },
    actionButtons: {
        justifySelf: "end",
    },
    navigationContainer: {
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
}))

type ReceiptNavigationProps = {
    isAuthenticated: boolean
    isSelectMode: boolean
    goToPreviousOrder: () => void
    goToNextOrder: () => void
    ordersLength: number
    currentMeetingIndex: number
}

export const ReceiptNavigation = ({
    isAuthenticated,
    isSelectMode,
    goToPreviousOrder,
    goToNextOrder,
    ordersLength,
    currentMeetingIndex,
}: ReceiptNavigationProps) => {
    const { classes } = useStyles()
    return (
        <Box className={classes.navigationContainer}>
            {isAuthenticated && !isSelectMode && (
                <Box className={classes.carouselContainer}>
                    <IconButton onClick={goToPreviousOrder} disabled={currentMeetingIndex === 0}>
                        <ChevronLeft />
                    </IconButton>
                    <Typography className={classes.carouselText}>
                        {currentMeetingIndex + 1}/{ordersLength}
                    </Typography>
                    <IconButton onClick={goToNextOrder} disabled={currentMeetingIndex === ordersLength - 1}>
                        <ChevronRight />
                    </IconButton>
                </Box>
            )}
        </Box>
    )
}
